import { Button } from 'components/atoms';
import React, { useState, FC } from 'react';
import styles from "./ContactForm.module.css";
import Modal from "react-modal";
import { ContactUsFormModal } from './components/CModal';
import he from "he";
import { TextEditor } from 'components/molecules';
import classNames from 'classnames';

document.getElementById('subpage') && Modal.setAppElement('#subpage');

type TContactUsProps = {
    data: {
        Title: string,
        SubText: string,
        ButtonText: string,
        SuccessTitle: string,
        SuccessDescription: string
    }
};

export const ContactUsForm: FC<TContactUsProps> = ({ data }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const handleOpen = (bool: boolean) => {
        setIsOpen(bool);
        document.getElementById('main-navigation')?.classList.remove('active');
        bool && document.querySelector('body')?.classList.add('no-scroll');
        !bool && document.querySelector('body')?.classList.remove('no-scroll');
    }
    
    return (
        <>
            <div className={classNames(styles.contactUsWrapper, 'animateonscroll')}>
                <div className="contentWrapper">
                    <h5 dangerouslySetInnerHTML={{ __html: he.decode(data?.Title) }} />
                    <div style={{ margin: '30px 0', display: 'flex', justifyContent: 'center' }}>
                        <Button onClick={() => handleOpen(!isOpen)} as="button">{he.decode(data?.ButtonText)}</Button>
                    </div>
                    <TextEditor className="text-center" data={data?.SubText} />
                </div>
                <ContactUsFormModal
                    data={data}
                    handleIsOpenChange={(bool: boolean) => handleOpen(bool)}
                    isOpen={isOpen} />
            </div>
        </>
    )
}